import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductsTopComponent } from './products-top/products-top.component';
import { PygOfferingComponent } from './pyg-offering/pyg-offering.component';
import { SubscribeComponent } from '../subscribe/subscribe.component';
import { TryDemoComponent } from '../try-demo/try-demo.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirLightBulb } from '@ng-icons/iconoir';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  imports: [
    ProductsTopComponent,
    PygOfferingComponent,
    SubscribeComponent,
    TryDemoComponent,
    TranslatePipe,
    LangRouterLink,
    NgIcon,
  ],
  providers: [provideIcons({ iconoirLightBulb })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsComponent {}
